import { service } from '@ember/service';
import type { AccountExtension as AccountModel } from 'tio-data/data/resources/account.ext';
import Component from '@glimmer/component';
import type RouterService from 'tio-employee/services/router';
import SyfAccountLinked from 'tio-employee/components/syf/account-linked';

interface SyfLinkingConfirmationRouteSignature {
  Args: {
    model: AccountModel;
  };
}

export class SyfLinkingConfirmationRouteComponent extends Component<SyfLinkingConfirmationRouteSignature> {
  @service declare router: RouterService;

  didConfirm = () => {
    this.router.transitionTo('authenticated.syf.account-confirmation');
  };

  <template><SyfAccountLinked @account={{@model}} @onConfirmation={{this.didConfirm}} /></template>
}
